import Connect from "../connect/connect";
import Welcome from "../../../welcome/screens/welcome/welcome";
import { useContext } from "react";
import MyNexarContext from "../../../../components/my-nexar-context/my-nexar-context";
import { useTranslation } from "react-i18next";

export default function ConnectGateway() {
  const context = useContext(MyNexarContext);
  const { t } = useTranslation();

  if (context.userAuthenticated === true) {
    return <Connect />;
  } else if (context.userAuthenticated === false) {
    const subtitle = (
      <span data-testid={"welcome-subtitle-activate"}>
        {t("letsActivateYourNexarConnectTrial")}
      </span>
    );
    return <Welcome subtitle={subtitle} />;
  } else {
    return <></>;
  }
}
